import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { CaretDown, CaretLeft, CaretRight, Check } from 'phosphor-react'
import './Stepper.scss'

function Stepper({ stepLabels, currentStep, onPrev, onNext, onStepPick }) {
  const [open, setOpen] = useState(false)
  const rootRef = useRef(null)

  useEffect(() => {
    if (!open) return undefined
    const onDocClick = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', onDocClick)
    return () => document.removeEventListener('mousedown', onDocClick)
  }, [open])

  const stepTitle = stepLabels[currentStep - 1] || stepLabels[0]

  const handlePick = async (stepIndex) => {
    if (typeof onStepPick === 'function') {
      await onStepPick(stepIndex)
    }
    setOpen(false)
  }

  return (
    <div className='custom-stepper-wrap' ref={rootRef}>
      <div className='custom-stepper' aria-label='Form steps'>
        <button
          type='button'
          className='stepper-segment stepper-segment--icon'
          aria-label='Previous step'
          onClick={onPrev}
        >
          <CaretLeft size={20} weight='bold' />
        </button>
        <button
          type='button'
          className='stepper-segment stepper-segment--label'
          aria-expanded={open}
          aria-haspopup='listbox'
          aria-label='Choose step'
          onClick={() => setOpen((v) => !v)}
        >
          <span className='stepper-label'>{stepTitle}</span>
          <CaretDown
            size={20}
            weight='bold'
            className={`stepper-caret ${open ? 'stepper-caret--open' : ''}`}
          />
        </button>
        <button
          type='button'
          className='stepper-segment stepper-segment--icon'
          aria-label='Next step'
          onClick={onNext}
        >
          <CaretRight size={20} weight='bold' />
        </button>
      </div>

      {open ? (
        <div className='stepper-dropdown' role='listbox'>
          {stepLabels.map((label, idx) => {
            const stepNum = idx + 1
            const completed = stepNum < currentStep
            const isCurrent = stepNum === currentStep
            return (
              <button
                key={label}
                type='button'
                role='option'
                aria-selected={isCurrent}
                className={`stepper-dropdown__item${
                  isCurrent ? ' stepper-dropdown__item--current' : ''
                }`}
                onClick={() => handlePick(stepNum)}
              >
                <span className='stepper-dropdown__check' aria-hidden='true'>
                  {completed ? (
                    <Check
                      size={18}
                      weight='bold'
                      className='stepper-dropdown__icon'
                    />
                  ) : null}
                </span>
                <span className='stepper-dropdown__text'>{label}</span>
              </button>
            )
          })}
        </div>
      ) : null}
    </div>
  )
}

Stepper.propTypes = {
  stepLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentStep: PropTypes.number.isRequired,
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onStepPick: PropTypes.func.isRequired,
}

export default Stepper
